export default "/assets/images/cc-filter-room-02.0ea68b936f7c946b.webp";